/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllOrgsApps = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application/getAll`,param).then(res => res.data)
}
const getAllAppsByOrgID = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application/getAllByOrganizationID`,param).then(res => res.data)
}
const getAllOrgByHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application/get-history`,param).then(res => res.data)
}
const createOrgApp = (orgApp) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application/create`,orgApp).then(res => res.data)
}
const editOrgApp = (orgApp) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application/update`,orgApp).then(res => res.data)
}
export {
    getAllOrgsApps,
    createOrgApp,
    editOrgApp,
    getAllAppsByOrgID,
    getAllOrgByHistory
}
